<template>
  <div>
    <div class="left-box">
      <div class="menu-header">
        <div class="menu-headerlogo">
          <img src="@/assets/images/logo.jpeg" class="header-avatar" />
        </div>
        <div class="header-name">{{ user.organ_name }}</div>
      </div>
      <div class="menus">
        <div
          class="menus-item"
          v-for="item in nav"
          :key="item.active"
          :class="{ active: active === item.active }"
          @click="go(item.url)"
        >
          <div class="menus-icon">
            <i :class="item.icon"></i>
          </div>
          <div class="menus-title">{{ item.name }}</div>
        </div>
      </div>
      <div class="tel">
        <p>服务电话</p>
        <span></span>
        <i class="iconfont icon-dianhua2"></i>
        <b>400 - 999 - 6541</b>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "leftPage",
  data() {
    return {
      nav: [
        {
          name: "我的申报",
          active: 0,
          url: "/orghome/index",
          icon: "iconfont icon-shenbao",
        },
        {
          name: "我的申报（待补充资料）",
          active: 1,
          url: "/orghome/project",
          icon: "iconfont icon-shenbao",
        },
        {
          name: "绩效管理",
          active: 8,
          url: "/orghome/project_performance",
          icon: "iconfont icon-shenbao",
        },
        {
          name: "项目月报",
          active: 7,
          url: "/orghome/project_month_report",
          icon: "iconfont icon-shenbao",
        },
        // {
        //   // name: "月报填写",
        //   name: "中期评审资料上传",
        //   active: 2,
        //   url: "/orghome/project_list/index",
        //   icon: "iconfont icon-shenbao",
        // },
        // {
        //   // name: "月报填写",
        //   name: "结项评审资料上传",
        //   active: 4,
        //   url: "/orghome/end_project_list/index",
        //   icon: "iconfont icon-shenbao",
        // },
        // {
        //   // name: "月报填写",
        //   name: "结项评审资料上传（补充）",
        //   active: 5,
        //   url: "/orghome/supply_project_list/index",
        //   icon: "iconfont icon-shenbao",
        // },
        // {
        //   name: "日志列表",
        //   active: 6,
        //   url: "/orghome/loglist",
        //   icon: "iconfont icon-xitongrizhi",
        // },
        {
          name: "个人中心",
          active: 3,
          url: "/orghome/pass",
          icon: "iconfont icon-zhanghao1",
        },
      ],
    };
  },
  props: {
    active: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    token() {
      return this.$store.state.shzztoken;
    },
    user() {
      return this.$store.state.shzzuser;
    },
  },
  components: {},
  created() {},
  methods: {
    go(path) {
      this.$router.replace(path);
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped lang="scss">
.left-box {
  width: 100%;
  .menu-header {
    width: 100%;
    min-height: 157px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px 25px;
    .header-name {
      width: 100%;
      text-align: center;
      font-size: 16px;
      color: #ffffff;
      font-weight: bold;
      line-height: 26px;
      padding-top: 15px;
    }
    .menu-headerlogo {
      width: 95px;
      height: 95px;
      border-radius: 85px;
      overflow: hidden;
      margin: 0 auto;
      .header-avatar {
        width: 100%;
        height: 100%;
        //object-fit: scale-down;
      }
    }

    .header-name {
      text-align: center;
      font-size: 14px;
      line-height: 18px;
      color: #fff;
      //margin-top: 12px;
    }
  }
  .tel {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    padding: 20px 35px;
    position: relative;
    border-top: 1px solid #ffffff;
    border-bottom: 1px solid #ffffff;
    p {
      width: 100%;
      font-size: 14px;
      color: #ffffff;
    }
    span {
      width: 30px;
      height: 2px;
      background: #ffffff;
    }
    b {
      font-size: 14px;
      color: #ffffff;
    }
    i {
      position: absolute;
      right: 0;
      bottom: -10px;
      z-index: -1;
      font-size: 90px;
      color: rgba(255, 255, 255, 0.1);
    }
  }
  .menus {
    width: 100%;

    .menus-item {
      width: 100%;
      height: 130px;
      border-top: 1px solid #ffffff;
      display: flex;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;
      &.active {
        border-left: 3px solid #ffffff;
        border-top: none;
        background: linear-gradient(
          to right,
          rgba(255, 255, 255, 0.6),
          rgba(255, 255, 255, 0)
        );
      }
      .menus-title {
        width: 100%;
        text-align: center;
        font-size: 16px;
        color: #ffffff;
        font-weight: bold;
        margin-top: 10px;
      }
      .menus-icon {
        width: 100%;
        text-align: center;
        i {
          font-size: 38px;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
